import { Injectable } from '@angular/core';
import { ICeuService } from './iceu.service';
import { CE_CreditType } from './ce-credit-type.model';
import { ApiService, PagedSearch } from '../../shared/index';
import { PagedResult as GenericPagedResult } from '../../shared/model/generic-paged-result.model';
//import moment from 'moment-es6';
import { MomentService } from '../../shared/moment/moment.service';

@Injectable()
export class CeuService implements ICeuService {
  private _momentService: MomentService;

  public _allCeCreditTypes: Promise<Array<CE_CreditType>> = null;
  public _ceCreditTypeCacheDate: any = null;

  public constructor(public _apiService: ApiService, momentService: MomentService) {
    this._momentService = momentService;
  }

  /**
   * get all ce credit types (continuing education credit types)
   */
  public getCeCreditTypes(force: boolean = false): Promise<Array<CE_CreditType>> {
    if (!force && this._allCeCreditTypes != null && this._momentService.getMoment().diff(this._ceCreditTypeCacheDate, 'minutes') < 2)
      return this._allCeCreditTypes;

    this._ceCreditTypeCacheDate = this._momentService.getMoment();

    let params: PagedSearch = new PagedSearch();
    params.PageNumber = 0;
    params.PageSize = 0;
    params.OrderBy = 'CECreditType:Asc';

    let url: string = '/CE_CreditTypes';
    this._allCeCreditTypes = this._apiService
      .getPaged(url, params)
      .then(pagedCeTypes => {
        return pagedCeTypes && pagedCeTypes.Result ? pagedCeTypes.Result : [];
      })
      .catch(err => {
        this._allCeCreditTypes = null;
        return Promise.reject(err);
      });

    return this._allCeCreditTypes;
  }

  /**
   * search for ce credit types (continuing education credit types)
   * @param params
   */
  public searchCeCreditTypes(params: PagedSearch = new PagedSearch()): Promise<GenericPagedResult<Array<CE_CreditType>>> {
    let url: string = '/CE_CreditTypes';
    return this._apiService.getPaged(url, params);
  }
}
